(function ($, Promise) {

	// Setup the prototype inheritance
	extend(BaseGame, Cybersnoop);

	// Constructor
	function Cybersnoop() {

		// Super constructor
		BaseGame.call(this);
		// this.resetDelay = 60 * 1000;
		this.resetDelay = -1;

		// Override toolbar screen since we have a screensaver
		this.activateToolbarFrom = 2;

		// Variable to hold data
		this.data = {}

		// Load data then init
		this.loadData();

		this.switches = [
			false,
			false,
			false,
			false,
			false,
			false
		];

		this.octopus = {
			arms: [
				{
					el: $('#octopus-arm-1'),
					minPercentage: 0.1,
					otherSideOffset: {
						start: 90,
						middle: 75,
						end: 115,
					},
				},
				{
					el: $('#octopus-arm-2'),
					minPercentage: 0.1,
					otherSideOffset: {
						start: 45,
						middle: 35,
						end: 65,
					},
				},
				{
					el: $('#octopus-arm-3'),
					minPercentage: 0.1,
					otherSideOffset: {
						start: 60,
						middle: 50,
						end: 84,
					},
				},
				{
					el: $('#octopus-arm-4'),
					minPercentage: 0.1,
					otherSideOffset: {
						start: 50,
						middle: 40,
						end: 55,
					},
				},
				{
					el: $('#octopus-arm-5'),
					minPercentage: 0.01,
					otherSideOffset: {
						start: 60,
						middle: 60,
						end: 53,
					},
				},
				{
					el: $('#octopus-arm-6'),
					minPercentage: 0.01,
					otherSideOffset: {
						start: 45,
						middle: 60,
						end: 50,
					},
				},
				{
					el: $('#octopus-arm-7'),
					minPercentage: 0.1,
					otherSideOffset: {
						start: 35,
						middle: 43,
						end: 40,
					},
				},
				{
					el: $('#octopus-arm-8'),
					minPercentage: 0.1,
					otherSideOffset: {
						start: 50,
						middle: 57,
						end: 39,
					},
				},
				{
					el: $('#octopus-arm-9'),
					minPercentage: 0.1,
					otherSideOffset: {
						start: 30,
						middle: 38,
						end: 6,
					},
				}
			]
		}

		// Create common properties
		for (var i = 0; i < this.octopus.arms.length; i++) {
			this.octopus.arms[i].lastState = false;
			this.octopus.arms[i].tween = false;
			this.octopus.arms[i].referencePath = Snap(this.octopus.arms[i].el.find('.reference-path').get(0));
			this.octopus.arms[i].dynamicPath = Snap(this.octopus.arms[i].el.find('.dynamic-path').get(0));
			this.octopus.arms[i].hand = this.octopus.arms[i].el.find('.octupus-hand');
			this.octopus.arms[i].counter = {
				value: 0,
				percentage: 0,
			}
		}

		// Bind TAB key to toggle guides
		$(window).bind("keydown", $.proxy(function (e) {
			if (e.keyCode == 9) {
				e.preventDefault();
				$("#guide, .guide").toggle();
			}
		}, this));
	}

	Cybersnoop.prototype.loadData = function () {

		// Load JSON for ZONES
		var json1 = $.ajax({
			url: "data/enigma.json",
			dataType: 'json',
			cache: false,
			complete: $.proxy(function (data) {
				this.data = JSON.parse(data.responseText);
			}, this)
		});

		// Wait for all
		Promise.all([
			json1.promise(),
		]).then($.proxy(function () {
			this.initGame();
		}, this));

	};

	Cybersnoop.prototype.initGame = function () {

		// Load SVGs
		convertSVGToInline();

		// Start serial server
		this.serial = new Serial("data/cybersnoop.json");

		// Go to first element
		this.goToScreen(1);

		for (var i = 0; i < this.octopus.arms.length; i++) {
			this.morphTo(this.octopus.arms[i], 0, this.octopus.arms[i].minPercentage);
		}
		// this.morphTo(this.octopus.arms[0], 3, 0.5);
		// this.morphTo(this.octopus.arms[4], 3, 0.5);


		// Bind keydown events
		$(window).on("keydown", $.proxy(function (e) {
			// if (e.keyCode >= 49 && e.keyCode <= 57) {
			// 	var key = parseInt(e.key.toLowerCase());
			// 	var id = key - 1;
			// 	// this.morphTo(this.octopus.arms[key - 1], 2.15, 1)
			// 	this.setSwitchValue(id, 1);
			// }
			if (e.keyCode >= 49 && e.keyCode <= 57) {
				var key = parseInt(e.key.toLowerCase());
				var id = constrain(key - 1, 0, this.switches.length - 1);
				this.setSwitchValue(id, !this.switches[id]);
			}
		}, this)).on("keyup", $.proxy(function (e) {
			// if (e.keyCode >= 49 && e.keyCode <= 57) {
			// 	var key = parseInt(e.key.toLowerCase());
			// 	var id = key - 1;
			// 	// this.morphTo(this.octopus.arms[key - 1], 2.15, this.octopus.arms[key - 1].minPercentage)
			// 	this.setSwitchValue(id, 0);
			// }
		}, this));


		// Bind serial events
		if (this.serial) {
			this.serial.on("action", $.proxy(function (e) {
				console.log(e.actionId, e.actionValue);
				if (e.actionId.substring(0, 6) == "switch") {
					var id = parseInt(e.actionId.substring(7, 8)) - 1;
					if (e.actionValue == "_PRESS") {
						// this.morphTo(this.octopus.arms[armId - 1], 2.15, 1)
						this.setSwitchValue(id, 0);
					} else if (e.actionValue == "_RELEASE") {
						// this.morphTo(this.octopus.arms[armId - 1], 2.15, 1)
						this.setSwitchValue(id, 1);
					}
				}
				this.resetTimer();
			}, this));
		}
	}

	Cybersnoop.prototype.setSwitchValue = function (id, value) {
		if (id < this.switches.length) {
			this.switches[id] = value;
			this.updateArmsWithSwitchValues();
		}
	}

	Cybersnoop.prototype.updateArmsWithSwitchValues = function (id, value) {

		// Define score
		var score = 0;
		for (var i = 0; i < this.switches.length; i++) {
			score += this.switches[i];
		}

		// Morph all arms
		this.morphAllTo(3.5, score / this.switches.length)
	}

	Cybersnoop.prototype.morphAllTo = function (duration, percentage) {
		for (var i = 0; i < this.octopus.arms.length; i++) {
			this.morphTo(this.octopus.arms[i], duration, map(percentage, 0, 1, this.octopus.arms[i].minPercentage, 1))
			// this.morphTo(this.octopus.arms[i], duration, percentage)
		}
	}

	Cybersnoop.prototype.morphTo = function (arm, duration, percentage) {

		// Convert percentage to real length
		var value = percentage * (arm.referencePath.getTotalLength() / 2 - 75);

		if (percentage == arm.lastState) {
			return;
		}

		// Stop current animation
		if (arm.tween) {
			arm.tween.kill();
			arm.tween = false;
		}

		arm.tween = TweenMax.to(arm.counter, duration, {
			value: value,
			percentage: percentage,
			onUpdate: $.proxy(function () {
				this.updatePath(arm, arm.counter.value, arm.counter.percentage);
			}, this),
			ease: Sine.easeOut
		});

		arm.lastState = percentage;
	}

	Cybersnoop.prototype.updatePath = function (arm, value, percentage) {

		var s1 = arm.referencePath;
		var s2 = arm.dynamicPath;
		var otherSideOffset = (percentage < 0.5) ? map(percentage, 0, 0.5, arm.otherSideOffset.start, arm.otherSideOffset.middle) : map(percentage, 0.5, 1, arm.otherSideOffset.middle, arm.otherSideOffset.end);

		// Calculate angle
		var p1 = s1.getPointAtLength(value)
		var p2 = s1.getPointAtLength(s1.getTotalLength() - value - otherSideOffset);
		var a = Snap.rad(Snap.angle(p1.x, p1.y, p2.x, p2.y));
		var dist = this.dist(p1, p2) * map(percentage, 0, 1, 3, 2.5);
		var p3 = {
			x: (p1.x + Math.cos(a + Math.PI * 0.55) * dist),
			y: (p1.y + Math.sin(a + Math.PI * 0.55) * dist),
		}
		var p4 = {
			x: (p2.x + Math.cos(a + Math.PI * 0.45) * dist),
			y: (p2.y + Math.sin(a + Math.PI * 0.45) * dist),
		}
		var p5 = s1.getPointAtLength(value + dist / 2)
		var p6 = s1.getPointAtLength(s1.getTotalLength() - value - otherSideOffset - dist / 2);

		var allCommands = [];
		var newPoints = s1.getSubpath(0, value);
		var commands = newPoints.split(/(?=[LMC])/);

		// First half
		for (var i = 0; i < commands.length; i++) {
			allCommands.push(commands[i]);
		}

		// Fill up with enough dot to morph nicely
		for (var i = 0; i < (this.countPoints(s1) - (commands.length - 1)); i++) {
			allCommands.push("l0,0");
		}

		// allCommands.push("L" + p3.x + "," + p3.y);
		// allCommands.push("L" + p4.x + "," + p4.y);
		allCommands.push("Q" + p5.x + "," + p5.y + " " + p3.x + "," + p3.y);
		allCommands.push("L" + p4.x + "," + p4.y);
		allCommands.push("Q" + p6.x + "," + p6.y + " " + p2.x + "," + p2.y);

		// Fill up with enough dot to morph nicely
		for (var i = 0; i < (this.countPoints(s1) - (commands.length - 1)); i++) {
			allCommands.push("l0,0");
		}

		// Last half
		var newPoints = s1.getSubpath(s1.getTotalLength() - value - otherSideOffset, s1.getTotalLength());
		var commands = newPoints.split(/(?=[LMC])/);
		for (var i = 0; i < commands.length; i++) {
			if (commands[i].startsWith('M')) {
				commands[i] = commands[i].trim().replace("M", "L");
			}
			allCommands.push(commands[i]);
		}

		// s2.animate({d: s3.attr("d")}, 500, mina.easein);
		// s2.attr({d: s3.attr("d")});
		s2.attr({d: allCommands.join("")});

		// Handle hand position
		arm.hand.css({
			left: (p3.x + p4.x) / 2,
			top: (p3.y + p4.y) / 2,
			transform: "rotate(" + (a) + "rad)"
		});

	}

	Cybersnoop.prototype.countPoints = function (path) {
		return Snap(path).attr("d").match(/[LlMmCcAa]/g);
	}

	Cybersnoop.prototype.dist = function (p1, p2) {
		return Math.sqrt((Math.pow(p1.x - p2.x, 2)) + (Math.pow(p1.y - p2.y, 2)))
	}

	Cybersnoop.prototype.goToScreen = function (screenId, callback) {

		// Super constructor
		BaseGame.prototype.goToScreen.call(this, screenId, callback);

		if (screenId == 2) {
			// this.requestHighlightTimer(8000);
		}

	}

	Cybersnoop.prototype.goToHome = function () {
		this.reset(1)
	}

	Cybersnoop.prototype.goToScrenSaver = function () {

		// Super constructor
		var shouldReset = BaseGame.prototype.shouldReset.call(this);

		if (shouldReset) {
			this.reset(1);
		}
	}

	Cybersnoop.prototype.reset = function (destinationScreen) {

		// Stop current animation
		if (this.letterOdysseyTimeline) {
			this.letterOdysseyTimeline.progress(1).kill();
			this.letterOdysseyTimeline = false;
		}

		// Define destination screen
		destinationScreen = destinationScreen || 1;

		// Go to screen
		this.goToScreen(destinationScreen);
	}


// Expose Timeline
	window.Cybersnoop = Cybersnoop;

})(jQuery, Promise);